"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arg = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ArgStr_1 = require("./args/ArgStr");
const ArgNum_1 = require("./args/ArgNum");
const ArgBool_1 = require("./args/ArgBool");
const ArgBtn_1 = require("./args/ArgBtn");
const ArgCode_1 = require("./args/ArgCode");
const ArgInfo_1 = require("./args/ArgInfo");
const ArgColor_1 = require("./args/ArgColor");
const ArgSelect_1 = require("./args/ArgSelect");
const ArgEnum_1 = require("./args/ArgEnum");
const ArgChar_1 = require("./args/ArgChar");
const Arg = ({ param, value, onChange, onSubmit, focus, compact }) => {
    switch (param.kind) {
        case 'str':
            return (React.createElement(ArgStr_1.ArgStr, { param: param, value: value, onChange: onChange, onEnter: onSubmit, focus: focus, compact: compact }));
        case 'num':
            return (React.createElement(ArgNum_1.ArgNum, { param: param, value: value, onChange: onChange, onEnter: onSubmit, focus: focus, compact: compact }));
        case 'bool':
            return React.createElement(ArgBool_1.ArgBool, { param: param, value: value, onChange: onChange, compact: compact });
        case 'color':
            return (React.createElement(ArgColor_1.ArgColor, { param: param, value: value, onChange: onChange, onEnter: onSubmit, focus: focus, compact: compact }));
        case 'select':
            return React.createElement(ArgSelect_1.ArgSelect, { param: param, value: value, onChange: onChange, onSubmit: onSubmit, compact: compact });
        case 'enum':
            return React.createElement(ArgEnum_1.ArgEnum, { param: param, value: value, onChange: onChange, compact: compact });
        case 'char':
            return React.createElement(ArgChar_1.ArgChar, { param: param, value: value, onChange: onChange, focus: focus, compact: compact });
        case 'btn':
            return React.createElement(ArgBtn_1.ArgBtn, { param: param, compact: compact });
        case 'code':
            return React.createElement(ArgCode_1.ArgCode, { param: param, compact: compact });
        case 'info':
            return React.createElement(ArgInfo_1.ArgInfo, { param: param, compact: compact });
        default:
            return null;
    }
};
exports.Arg = Arg;
